module.exports = __webpack_public_path__ + "img/caratula_2027.3f8850c7.png";